function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.76224 0.247212C6.22882 1.36198 5.82126 2.53626 5.54492 3.74682C6.21567 3.90475 6.90177 3.99849 7.59544 4.0251V0.14502C7.31423 0.162018 7.03613 0.196101 6.76224 0.247212Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.6441 4.59912C9.91643 4.76974 9.17357 4.86892 8.422 4.89553V7.12319H10.8951C10.8736 6.27333 10.7896 5.42935 10.6441 4.59912Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M9.2551 0.247183C8.98129 0.196101 8.70324 0.162018 8.42212 0.14502V4.02487C9.11565 3.99855 9.80095 3.9058 10.4723 3.74786C10.1959 2.53675 9.78805 1.36146 9.2551 0.247183Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M8.42212 11.0918V14.9716C8.70338 14.9546 8.98154 14.9205 9.25546 14.8694C9.77405 13.7865 10.1905 12.6154 10.4746 11.3693C9.80252 11.2111 9.11645 11.1181 8.42212 11.0918Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M11.7223 7.99365C11.7003 8.91692 11.6085 9.8346 11.4479 10.7366C12.2699 10.9934 13.0607 11.3409 13.816 11.7779C14.5496 10.6643 14.9766 9.36409 15.0513 7.99365H11.7223Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M5.54309 11.3693C5.81024 12.5409 6.21065 13.7176 6.76223 14.8694C7.03615 14.9205 7.31433 14.9546 7.59557 14.9716V11.0918C6.90127 11.1181 6.21516 11.2111 5.54309 11.3693Z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M5.37337 4.59863C5.22809 5.42848 5.14377 6.27243 5.12231 7.12357H7.59542V4.89635C6.84376 4.86951 6.10022 4.76914 5.37337 4.59863Z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M2.2015 3.33936C1.46794 4.45299 1.04093 5.75324 0.966187 7.1237H4.29529C4.31744 6.19847 4.40998 5.28108 4.57097 4.37976C3.75015 4.12365 2.95591 3.77561 2.2015 3.33936Z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M4.74293 11.5908C4.05462 11.8104 3.38101 12.0997 2.71887 12.4719C3.51983 13.4248 4.53977 14.1614 5.71736 14.5857C5.30485 13.6212 4.97861 12.6195 4.74293 11.5908Z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M2.71936 2.64472C3.36714 3.00855 4.04559 3.30314 4.74509 3.52592C4.98075 2.49834 5.30655 1.49579 5.71895 0.530762C4.59184 0.936579 3.55682 1.64848 2.71936 2.64472Z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M4.29516 7.99365H0.966187C1.04093 9.36409 1.46792 10.6643 2.20145 11.7779C2.95599 11.3413 3.74669 10.9937 4.56962 10.7366C4.40899 9.8346 4.31716 8.91692 4.29516 7.99365Z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M10.2985 0.530762C10.7105 1.4957 11.0363 2.49901 11.272 3.52693C11.9758 3.30262 12.649 3.01012 13.2985 2.64507C12.4954 1.68963 11.4742 0.954041 10.2985 0.530762Z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M5.12207 7.99365C5.14336 8.84319 5.22705 9.68755 5.37197 10.518C6.10008 10.3472 6.84332 10.2479 7.59537 10.2213V7.99365H5.12207Z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M13.8161 3.33936C13.0764 3.76733 12.2865 4.11882 11.4462 4.38118C11.6073 5.28281 11.7 6.19994 11.7222 7.12362H15.0513C14.9766 5.75318 14.5496 4.45299 13.8161 3.33936Z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M8.42212 7.99365V10.2213C9.17414 10.2479 9.9174 10.3472 10.6455 10.518C10.7904 9.68755 10.8741 8.84319 10.8954 7.99365H8.42212Z"
});

var _ref17 = /*#__PURE__*/React.createElement("circle", {
  cx: 14.2104,
  cy: 14.5518,
  r: 5.9371,
  fill: "#F1F2F5"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M12.6682 16.5278V15.5863H13.8395V12.584L12.9425 13.1103L12.5051 12.2726L14.1731 11.3015H14.9886V15.5863H16.0857V16.5278H12.6682Z",
  fill: "#23244D",
  fillOpacity: 0.5
});

var SvgTimezone1Icon = function SvgTimezone1Icon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTimezone1Icon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/timezone-1-icon.22855039.svg";
export { ForwardRef as ReactComponent };